import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What is Progressive Web App Development?",
    answer: `<p>An application that is developed with web platform technologies and offers a user experience akin to a platform-specific app is known as a progressive web app (PWA). A PWA can run across multiple devices and platforms from a single codebase, just like a website.</p>`,
  },
  {
    question: "How much does progressive web app development cost?",
    answer: `<p>On average, the development of a progressive web app costs around  $15,000 to $150,000. It can go up from this amount based on extra functions and features requested from our clients.</p>`,
  },
  {
    question:
      "Which technical framework works best for producing a Progressive Web App (PWA) of the highest caliber?",
    answer: ` <p>Google's AngularJS is the greatest PWA Framework for creating intricate progressive web applications. AngularJS facilitates the development of sophisticated online applications with ease by providing a library of UI components, progressive improvements, and powerful tools. It also supports TypeScript.</p>`,
  },
  {
    question: "How are progressive web apps different from regular web apps?",
    answer: `<p>Progressive web apps (PWAs) and native apps vary primarily in that PWAs may adjust to different operating systems and sizes of screens. A PWA, in contrast to native apps, can be opened on iOS, Android, Windows, or any other OS, and it will always provide an excellent user experience.</p>`,
  },
  {
    question: "What is better- PWA or Native Apps?",
    answer: `<p>While native applications can offer better performance as well as access to device features, PWAs have the benefit of being cross-platform compatible. It's critical to take into account elements like the intended functionality, target audience, and available development resources.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ backgroundL: "#f9f9f9" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Progressive Web App Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
